import {
  deleteUser as FBDeleteUser,
  sendEmailVerification as FBSendEmailVerification,
  sendPasswordResetEmail as FBSendPasswordResetEmail,
  signOut as FBSignOut,
  User,
  updateProfile,
} from 'firebase/auth';

import { auth } from '@helpers/firebase/Initialize';
import { Photo } from '@types';

export async function updateName(user: User, name: string) {
  return await updateProfile(user, {
    displayName: name,
  });
}

export async function updatePhoto(user: User, photo: Photo) {
  return await updateProfile(user, {
    photoURL: photo.uri,
  });
}

export async function sendPasswordResetEmail(email: string) {
  return await FBSendPasswordResetEmail(auth, email);
}

export async function sendEmailVerification(user: User) {
  return await FBSendEmailVerification(user);
}

export async function signOut() {
  return await FBSignOut(auth);
}

export async function deleteUser(user: User) {
  await FBDeleteUser(user);
}
